// Settings screen (Screen 7) — PSD §10.2. 3 collapsibles. Live theme toggle.

import { UnitToggle } from 'calc-controls';
import { useStore } from '../store/selectors';
import { Accordion } from '../components/results/Accordion';
import { useAboutOpener } from '../components/common/aboutContext';
import { IntegrationsSection } from '../components/settings/IntegrationsSection';
import { AccessSection } from '../components/settings/AccessSection';
import { AppLockSection } from '../components/settings/AppLockSection';
import { PlatformSection } from '../components/settings/PlatformSection';
import { DemoDataSection } from '../components/settings/DemoDataSection';

export function Settings() {
  const setTheme = useStore((s) => s.setTheme);
  const theme = useStore((s) => s.settings.theme);
  const openAbout = useAboutOpener();

  return (
    <div>
      <h1 className="screen-title">Settings</h1>
      <Accordion title="Integrations" defaultOpen>
        <IntegrationsSection />
      </Accordion>
      <Accordion title="Access" defaultOpen>
        <AccessSection />
      </Accordion>
      <Accordion title="App Lock">
        <AppLockSection />
      </Accordion>
      <Accordion title="Demo Data">
        <DemoDataSection />
      </Accordion>
      <Accordion title="Platform">
        <div className="headline-grid">
          <UnitToggle
            label="Theme"
            options={[
              { label: 'Light', value: 'light' },
              { label: 'Dark', value: 'dark' },
            ]}
            value={theme}
            onChange={(v) => {
              setTheme(v as 'light' | 'dark');
              document.documentElement.setAttribute('data-theme', v);
            }}
          />
        </div>
        <PlatformSection />
      </Accordion>

      <hr className="settings-about-divider" />

      <button
        type="button"
        className="settings-about-button"
        onClick={openAbout ?? undefined}
        disabled={!openAbout}
      >
        About
      </button>
    </div>
  );
}
